import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'positive', 
  icon, 
  trend = [],
  loading = false 
}) => {
  const changeColor = changeType === 'positive' ?'text-success' 
    : changeType === 'negative' ?'text-error' :'text-muted-foreground';

  const changeIcon = changeType === 'positive' ?'TrendingUp' 
    : changeType === 'negative' ?'TrendingDown' :'Minus';

  return (
    <div className="bg-card rounded-lg border border-border p-2 shadow-warm hover:shadow-warm-md transition-all duration-250">
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <p className="text-[10px] text-muted-foreground font-caption mb-0.5">{title}</p>
          {loading ? (
            <div className="h-6 w-16 bg-muted animate-pulse rounded"></div>
          ) : (
            <h3 className="text-base font-heading font-bold text-foreground font-data">
              {value}
            </h3>
          )}
        </div>
        <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={14} color="var(--color-primary)" />
        </div>
      </div>
      {change && (
        <div className="flex items-center gap-1">
          <div className={`flex items-center gap-0.5 ${changeColor}`}>
            <Icon name={changeIcon} size={10} />
            <span className="text-[10px] font-medium font-data">{change}</span>
          </div>
          <span className="text-[9px] text-muted-foreground">مقارنة بالشهر السابق</span>
        </div>
      )}
      {trend && trend?.length > 0 && (
        <div className="mt-2 flex items-end gap-0.5 h-6">
          {trend?.map((value, index) => (
            <div
              key={index}
              className="flex-1 bg-primary/20 rounded-t"
              style={{ height: `${value}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;